module Meevo.Plugins.DrawerManager {
    "use strict";

    export class ClosingDrawerSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        private isEditing: boolean;
        public isReadOnly: boolean = true;
        private promiseReadOnly: ng.IPromise<any> = null;
        canViewExpectedClosingTotals: boolean = true;

        constructor(
            protected drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean,
            private registerSettings: any) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.ClosingDrawer, drawerManagerContext, "closingDrawer", personalHeader, personalFooter);
            securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_DRAWERMANAGER_ACTION_VIEWEXPECTEDCLOSINGTOTALS).then(result => {
                this.canViewExpectedClosingTotals = result === Model.SecurityAccessEnum.Grant;
            });

        }

        reset() {
            super.reset();
            this.isEditing = false;
            this.isReadOnly = true;
            this.promiseReadOnly = null;
        }
        getSectionName() {
            return this.context.selectedDrawer.displayName + " - Closing";
        }
        initialize(isEditing: boolean) {
            this.isEditing = isEditing;
            this.setReadOnlyState();
        }
        cancel = () => {
            this.context.isOpeningClosingDrawer = false;
            this.context.closeSection();
        }
        save = (doPrint = false) => {
            let actualCashInDrawer = +this.context.selectedDrawer.drawerSession.actualCashInDrawer;
            let cashLeftInDrawer = +this.context.selectedDrawer.drawerSession.cashLeftInDrawer;
            if (this.isClosingNoteRequired() && this.context.selectedDrawer.drawerSession.note.length === 0) {
                return;
            }
            if (cashLeftInDrawer > actualCashInDrawer) {
                this.modalService.alert("Cash left in Drawer should not be greater than the Actual cash in Drawer.");
            }
            else if (this.context.selectedDrawer.drawerState === Meevo.Model.DrawerStateEnum.Close) { //this.isEditing
                this.closeDrawer(doPrint);
            }
            else {
                this.modalService.confirm("MESSAGE_CONFIRM_CLOSE_DRAWER").then((result: boolean) => {
                    if (result) {
                        this.closeDrawer(doPrint);
                        this.checkOnHoldWarning();
                        this.context.isOpeningClosingDrawer = false;
                    }
                });
            }
        }

        checkOnHoldWarning() {
            if (this.registerSettings.archiveSalesOnHoldSystemMaintenanceDate && this.registerSettings.archiveSalesOnHoldSystemMaintenanceDateWarningWindow &&
                moment(this.registerSettings.archiveSalesOnHoldSystemMaintenanceDate) >= moment().startOf("day") &&
                moment().startOf("day") > moment(this.registerSettings.archiveSalesOnHoldSystemMaintenanceDate).add(this.registerSettings.archiveSalesOnHoldSystemMaintenanceDateWarningWindow * -1, "day")) {

                let request = {
                    criteria: {
                        holdTypes: [Model.HoldTypeEnum.Register, Model.HoldTypeEnum.Recovery]
                    }
                };
                this.dataService.getCount(this.appSettings.API_ENDPOINTS.saleHold, request)
                    .then(count => {
                        if (count > 0) {
                            this.modalService.alert(this.$translate.instant("MESSAGE_SALES_ON_HOLD", { onHoldCount: count, meevoUpgradeDate: moment(this.registerSettings.archiveSalesOnHoldSystemMaintenanceDate).format("MM/DD/YYYY") }),
                                Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                        }
                    });
            }
        }

        cloneDrawerSession(drawerSession: Meevo.Model.DrawerSession): Meevo.Model.PatchDrawerSession {
            var newDS: Meevo.Model.PatchDrawerSession = _.clone<Meevo.Model.DrawerSession>(drawerSession);
            return newDS;
        }

        closeDrawer(doPrint = false) {
            var closePromise;
            if (this.isEditing) {
                let patchSession = this.cloneDrawerSession(this.context.selectedDrawer.drawerSession);
                patchSession.updateState = Meevo.Model.DrawerStateEnum.Close;
                closePromise = this.context.patchDrawerSession(patchSession);
            }
            else {
                closePromise = this.context.closeDrawerSession();
            }

            closePromise.then(() => {
                if (doPrint) {
                    this.printDepositSlip(true);
                } else {
                    if (this.context.insideRegister) {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_CLOSED, { name: "register" });
                    }
                    if (this.isEditing) {
                        this.context.closeSection();
                    }
                    else {
                        this.context.replaceOpenSection(DrawerManagerSectionTypeEnum.DrawerClosed, DrawerManagerSectionTypeEnum.DrawerOpened);
                    }
                }
            }).catch(e => {
                if (e && e.errorCode == "STALE_DATA") {
                    this.modalService.message("MESSAGE_DRAWER_CLOSING_STALE_DATA");
                }
            });
        }
        getAmountDifference(paymentItem) {
            return this.context.subtractNormalizedNumbers(isNaN(+paymentItem.actualAmount) ? 0 : +paymentItem.actualAmount, paymentItem.amount);
        }
        getTotalDifference(forCash: boolean) {
            let drawerSession = this.context.selectedDrawer.drawerSession;
            // first one is for Cash
            var totalDiff = this.context.subtractNormalizedNumbers((drawerSession.actualCashInDrawer || 0), this.getTotalCashInDrawer());
            // then, compute all except for Cash
            if (!forCash) {
                drawerSession.aggregatedPaymentTransactions.forEach((item, ndx, arr) => {
                    if (item.paymentCategory != Meevo.Model.PaymentCategoryEnum.Cash) {
                        if (item.actualAmount) {
                            let diff = this.context.subtractNormalizedNumbers((isNaN(item.actualAmount) ? 0 : item.actualAmount), item.amount)
                            totalDiff = this.context.addNormalizedNumbers(totalDiff, diff);
                        }
                        else {
                            totalDiff = this.context.subtractNormalizedNumbers(totalDiff, item.amount);
                        }
                    }
                });
            }
            return totalDiff;
        }
        getTotalTipsCollected() {
            return (this.context.selectedDrawer && this.context.selectedDrawer.drawerSession && this.context.selectedDrawer.drawerSession.summary) ? this.context.selectedDrawer.drawerSession.summary.totalTip : 0;
        }
        getTotalCashTransactions() {
            let cashPayment = this.context.getCashTransactionPaymentItem();
            return this.context.addNormalizedNumbers((cashPayment ? cashPayment.amount : 0),
                this.context.selectedDrawer.drawerSession.openCashAmount, this.context.getPayInOutTotal(Model.PaymentCategoryEnum.Cash));
        }
        getTotalCashInDrawer() {
            return this.getTotalCashTransactions();
        }

        printDepositSlip(isSaved: boolean = false) {
            if (!isSaved) {
                this.modalService.confirm("MESSAGE_DEPOSIT_SLIP_PRINT").then((result) => {
                    if (result) {
                        this.save(true);
                    }
                });
            } else {
                const drawerId = this.context.selectedDrawer.drawerSession.drawerId;
                const drawerSessionId = this.context.selectedDrawer.drawerSession.id;
                let options = {
                    url: `/api/Drawer/${drawerId}/Session/${drawerSessionId}/DepositSlip`,
                    method: 'GET',
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                        languageDictionary: {
                            'LABEL_CHECK_DEPOSIT': this.$translate.instant('LABEL_CHECK_DEPOSIT'),
                            'LABEL_CHECK_DETAIL': this.$translate.instant('LABEL_CHECK_DETAIL'),
                        },
                    }
                }
                // TODO this.context.selectedPrinter must match the one selected in the print service
                this.printService.printCustom(options)
                    .then(() => {
                        if (this.context.insideRegister) {
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_CLOSED, { name: "register" });
                        }
                        if (this.isEditing) {
                            this.context.closeSection();
                        }
                        else {
                            this.context.replaceOpenSection(DrawerManagerSectionTypeEnum.DrawerClosed, DrawerManagerSectionTypeEnum.DrawerOpened);
                        }
                    });
            }
        }

        gotoOtherPaymentListing(paymentType) {
            this.context.gotoCreditCardListings(paymentType, true, this.isReadOnly, true);
        }

        getState() {
            return {
                isEditing: this.isEditing,
                isReadOnly: this.isReadOnly
            };
        }
        setState(state) {
            if (state) {
                if (state.isEditing != undefined || state.isEditing != null) {
                    this.isEditing = Boolean(state.isEditing);
                }
                if (state.isReadOnly != undefined || state.isReadOnly != null) {
                    this.isReadOnly = Boolean(state.isReadOnly);
                }
            }
        }

        setReadOnlyState() {
            var securityKey = this.isEditing
                ? Meevo.Components.Common.SecurityKeys.REGISTER_DRAWERMANAGER_ACTION_EDITCLOSINGCASH
                : Meevo.Components.Common.SecurityKeys.REGISTER_DRAWERMANAGER_ACTION_CLOSE;
            if (this.promiseReadOnly) {
                let oldPromise = this.promiseReadOnly;
                this.promiseReadOnly = oldPromise.then(() => {
                    return this.setReadOnlyStateWorker(securityKey);
                });
            }
            else {
                this.promiseReadOnly = this.setReadOnlyStateWorker(securityKey);
            }
        }

        setReadOnlyStateWorker(securityKey) {
            return this.securityService.checkSecurityKey(securityKey)
                .then(result => {
                    this.isReadOnly = (result === Meevo.Model.SecurityAccessEnum.Hide);
                })
                .finally(() => {
                    this.promiseReadOnly = null;
                });
        }

        isClosingNoteRequired() {
            return (this.context.selectedDrawer.isOverShortClosingNoteRequired && this.getTotalDifference(false) != 0);
        }

        refresh() {
            this.context.getDrawerSession(this.context.selectedDrawer.id, true, this.context.selectedDrawer.drawerSession.id, true);
        }

        getDrawerStateLabel(drawerState: Model.DrawerStateEnum) {
            let dateUpdated = _.chain(this.context.selectedDrawer.drawerSession.drawerSessionHistory)
                .where({ drawerState: drawerState })
                .sortBy(function (sessionHistory) { return sessionHistory.dateUpdated; })
                .last()  //possible multiple updates to the session after closing or opening, so we want date when session was Open/Closed at last
                .value();
            return dateUpdated;
        }
    }

}